// eslint-disable-next-line import/prefer-default-export
export const CPCR_PROTOCOL_ENTITY_TYPE = 'cpcr-protocol';
